import { render, staticRenderFns } from "./VersionAddLayer.vue?vue&type=template&id=3f4924ec&scoped=true&"
import script from "./VersionAddLayer.vue?vue&type=script&lang=js&"
export * from "./VersionAddLayer.vue?vue&type=script&lang=js&"
import style0 from "./VersionAddLayer.vue?vue&type=style&index=0&id=3f4924ec&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f4924ec",
  null
  
)

export default component.exports